import { useLoaderData, useNavigate, useSearchParams, useSubmit } from "react-router-dom";
import { simpleStatusColorCode } from "../common/functions";
import { ListLoaderData, timeCardStatus } from "./types";
import ServerFooter from "../common/ServerFooter";
export default function AllTimeCardsList(){
    const { users, week, weeks, status, total } = useLoaderData() as ListLoaderData;
    const navigate = useNavigate();
    const submit = useSubmit();
    const [searchParams, setSearchParams] = useSearchParams();
    const handleExport = async () => {
        const formData = new FormData();
        formData.append("week", week);
        submit(formData, {method: "post", action: "Export"});
    }
    return (
        <div className = {"cssContent" + (total > 0?" pb8rem":"")}>
            <div className="d-flex align-items-center m-2">
                <label className="fw-bold me-2">Week:</label>
                <select
                    className="form-select w-auto me-3"
                    value={week}
                    onChange={e => navigate(`/AllTimeCards/${e.currentTarget.value}`)}
                >
                    {weeks.map(w => (
                        <option key = {w} value = {w}>{w}</option>
                    ))}
                </select>
                <label className = "fw-bold me-2">Status:</label>
                <select
                    className = "form-select w-auto me-3"
                    value = {status}
                    onChange = {e => {
                        const params = new URLSearchParams(searchParams);
                        if(e.target.value === "") params.delete("status");
                        else params.set("status", e.target.value);
                        params.set("page", "1");
                        setSearchParams(params, { replace: false });  
                    }}
                >
                    <option value = "">All</option>
                    {timeCardStatus.map(s=> <option key = {s} value = {s}>{s}</option>)}
                </select>
                <button type = "button" className="btn btn-primary" onClick={handleExport}>Export</button>
            </div>
            {!users.length
                ? <div className="cssLoading">No timecards for this week.</div>
                : <div className="table-responsive mt-3">
                    <table className="table table-hover">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {users.map(u => (
                                <tr
                                    key={u.userId}
                                    className="pointer"
                                    onClick={() => navigate(`/AllTimeCards/${week}/${u.userId}`)}
                                >
                                    <td>
                                        <strong style={{ color: simpleStatusColorCode[u.status] }}>
                                            {u.userName}
                                        </strong>
                                    </td>
                                    <td>
                                        <strong style={{ color: simpleStatusColorCode[u.status] }}>
                                            {u.status}
                                        </strong>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            }
            {total?
            <ServerFooter
                length = {total}
            />
            :null}
        </div>
    );
}